<template>
  <div class="home-page-wrapper content0-wrapper">
    <div class="bg"></div>
    <div class="content1 home-page">
      <div class="content5-list">
        <div 
          v-for="(item, index) in productList" 
          :key="index"
          class="content5-list-item"
        >
          <div class="content5-list-item-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="content5-list-item-content">
            <div class="content5-list-item-content-p1">
              {{ item.description }}
            </div>
            <img :src="item.image" alt="" />
            <div class="content5-list-item-content-p2">
              相关解决方案
            </div>
            <div class="content5-list-item-content-p3">
              {{ item.solution }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Img1 from '@/assets/product_2.png'
import Img2 from '@/assets/product_3.png'
import Img3 from '@/assets/product_4.png'
import Img4 from '@/assets/product_5.png'

export default {
  name: 'Content0',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'content0'
    }
  },
  data() {
    return {
      props: {},
      productList: [
        {
          title: '智慧城市',
          description: '陕西省安康市智慧治理指挥中心建设项目、安康市紫阳新型智慧城市建设项目 枝江市雪亮工程建设项目、陕西省勉县雪亮工程建设项目',
          image: Img1,
          solution: '城市智能运行可视化'
        },
        {
          title: '数字乡村',
          description: '“三管三创三服务”是竹林社区在乡村数字化建设过程中的积极探索，泰跃卫星在湖北省审计厅的指导下，与社区“两委”班子一道，大力推动数字技术与实体深度融合，不断驱动创新创造，将竹林社区带入乡村发展新赛道。',
          image: Img2,
          solution: '数字乡村综合治理'
        },
        {
          title: '智慧教育',
          description: '校园安全风险防控平台采用“大数据+物联网”技术，铸就校园安全由外至内三重防线，为校园安全提供“事前预防、事发预警、事中应急、事后处理”的全方位安全闭环管理，打造“全域、全时、全程、全员”的360度校园安全防护体系',
          image: Img3,
          solution: '校园安全风险防控'
        },
        {
          title: '智慧园区',
          description: '泰跃智慧园区集成5G、LoRa、人工智能等新一代信息技术，以视频监控为主、可视化展现为辅，实现社区“人、屋、车、场、网”等的管理立体化、可视化和可控化，构建管理、防范、控制于一体的园区治安防控体系，为基层管理部门提供强大的数据支撑，铸就园区治理数字化新平台。',
          image: Img4,
          solution: '总体态势可视化'
        }
      ]
    }
  },
  mounted() {
    // 初始化props
    this.props = { ...this.$props }
    delete this.props.dataSource
    delete this.props.isMobile
  }
}
</script>

<style scoped>
.content0-wrapper {
  width: 100%;
  overflow: hidden;
}

.content0-content {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.bg {
  width: 100%;
  height: 440px;
  background: url(@/assets/product_1.png) no-repeat center center / 100% 100%;
  z-index: -1;
}

.content1 {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 20px 0;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

.content5-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 84px;
}

.content5-list-item {
  position: relative;
  width: 590px;
  height: 773px;
  background: #ffffff;
  border: 2px solid #eff3fc;
  border-radius: 8px;
  margin-bottom: 60px;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
}

.content5-list-item-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 28px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #242934;
  width: 590px;
  height: 72px;
  background: linear-gradient(90deg, #eff3fc, #f4f5fd);
  border-radius: 8px 8px 0px 0px;
  span {
    margin-left: 56px;
  }
}


.content5-list-item-content {
  height: 100%;
  background: url(@/assets/quotation.png) no-repeat;
  background-position: 430px 54px;
  background-size: 110px 110px;
  position: relative;
}

.content5-list-item-content img {
  position: absolute;
  left: 60px;
  top: 188px;
  object-fit: cover;
}

.content5-list-item-content-p1 {
  margin-top: 26px;
  margin-left: 56px;
  width: 474px;
  font-size: 14px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #242934;
  line-height: 28px;
}

.content5-list-item-content-p2 {
  position: absolute;
  left: 60px;
  bottom: 200px;
  width: 96px;
  font-size: 16px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: bold;
  color: #242934;
  line-height: 28px;
}

.content5-list-item-content-p3 {
  position: absolute;
  left: 60px;
  bottom: 145px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 156px;
  height: 34px;
  background: #f2f3f7;
  font-size: 14px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #0a79f7;
}

.copyright-wrapper {
  margin-top: 60px;
  padding: 20px;
  background-color: #333;
}

.copyright {
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.copyright a {
  color: #fff;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

.content2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 90px;
  margin-bottom: 175px;
  width: 197px;
  height: 49px;
  border: 1px solid #c6d5e2;
  border-radius: 2px;
  font-size: 18px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #a3b7c9;
  margin: 0 auto 175px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content0-content {
    padding: 60px 20px;
  }

  .content1 {
    padding: 60px 20px 0;
  }

  .content5-list {
    margin-top: 60px;
  }

  .content5-list-item {
    width: 100%;
    height: auto;
    min-height: 600px;
  }

  .content5-list-item-title {
    width: 100%;
    font-size: 24px;
  }

  .content5-list-item-title span {
    font-size: 20px;
  }

  .content5-list-item-content {
    height: auto;
    padding: 20px;
    background: none;
  }

  .content5-list-item-content img {
    position: static;
    width: 100%;
    height: auto;
    margin: 20px 0;
  }

  .content5-list-item-content-p1 {
    margin: 0 0 20px 0;
    width: 100%;
  }

  .content5-list-item-content-p2 {
    position: static;
    margin: 20px 0;
    text-align: center;
  }

  .content5-list-item-content-p3 {
    position: static;
    margin: 20px 0;
    width: 100%;
  }

  .content2 {
    margin: 60px auto 120px;
  }
}
</style>